import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DocumentPendingOutlined = ({
  size = 20,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path
        d="M8.25 16.25H5.2c-.792 0-1.442-.65-1.442-1.442V5.192c0-.792.65-1.442 1.442-1.442h8.158c.792 0 1.442.65 1.442 1.442v2.433c.45.175.867.417 1.25.7V5.192A2.696 2.696 0 0 0 13.358 2.5H5.2a2.696 2.696 0 0 0-2.692 2.692v9.625A2.696 2.696 0 0 0 5.2 17.508h4.367a5.52 5.52 0 0 1-1.317-1.25v-.008Z"
        fill={color}
      />
      <Path
        d="M14.017 13.708h-1.4a.54.54 0 0 1-.542-.541v-2a.54.54 0 1 1 1.083 0v1.458h.859a.54.54 0 1 1 0 1.083Z"
        fill={color}
      />
      <Path
        d="M12.708 8.625c-.85 0-1.683.258-2.391.717a.532.532 0 0 0-.509-.534c-.283-.008-.558.209-.575.509l-.075 1.366c-.008.15.05.309.159.417.1.1.241.158.383.158h.033l1.317-.075a.542.542 0 0 0 .508-.575.54.54 0 0 0-.441-.491 3.364 3.364 0 0 1 1.583-.409 3.338 3.338 0 0 1 2.892 5 .545.545 0 0 0 .475.817c.183 0 .366-.1.466-.275a4.45 4.45 0 0 0 .592-2.208 4.424 4.424 0 0 0-4.417-4.417ZM8.858 13.975a.549.549 0 0 1-.541-.492 3.812 3.812 0 0 1-.025-.441.54.54 0 1 1 1.083 0c0 .108 0 .225.017.333a.531.531 0 0 1-.484.592H8.85l.008.008ZM12.542 17.45h-.025a4.21 4.21 0 0 1-.784-.1.544.544 0 0 1 .242-1.058c.192.041.392.066.583.075.3.008.534.266.517.566a.536.536 0 0 1-.542.517h.009ZM10.05 16.4a.551.551 0 0 1-.375-.15 3.87 3.87 0 0 1-.517-.592.544.544 0 0 1 .117-.758.544.544 0 0 1 .758.117c.117.158.25.308.392.441.217.209.225.55.025.767a.524.524 0 0 1-.392.167l-.008.008ZM14.55 17a.528.528 0 0 1-.475-.283.544.544 0 0 1 .217-.734c.1-.05.191-.108.283-.175.25-.166.583-.1.75.15.167.25.1.584-.15.75-.125.084-.25.159-.375.225a.567.567 0 0 1-.258.067h.008Z"
        fill={color}
      />
      <Path
        d="M5.608 6.667H12.5M5.608 9.617H7.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DocumentPendingOutlined
